export default __webpack_public_path__ + "static/media/factor_item_2.2346a7f6.png";